import React from 'react';

import { JFOverlayController } from 'jf/common/useJFOverlay';

import { StudyBuilderPage } from './StudyBuilderPage';
import { StudyBuilderStateProvider } from './StudyBuilderState';
import { StudyUpdaterProvider } from './useStudyUpdater';

export const StudyBuilderController: React.FC = () => {
  return (
    <StudyBuilderStateProvider>
      <StudyUpdaterProvider>
        <JFOverlayController>
          <StudyBuilderPage />
        </JFOverlayController>
      </StudyUpdaterProvider>
    </StudyBuilderStateProvider>
  );
};
